import { Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import moment from "moment";
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import Currency from "utils/currency";
import snakeToCamel from "utils/snakeToTitle";
import { MonoText } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    paddingBottom: "0 !important"
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const TransactionInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.transaction);
  const classes = useStyles();


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Transaction Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Date</TableCell>
              <TableCell>{moment(model.date).format("DD/MM/YYYY - HH:mm")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Reference</TableCell>
              <TableCell><MonoText>{model.reference}</MonoText></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Amount</TableCell>
              <TableCell>{Currency.compress(model.amount, model.currency)}</TableCell>
            </TableRow>
            {model?.data?.current !== 'undefined' && <TableRow>
              <TableCell className={classes.header}>Current</TableCell>
              <TableCell>{Currency.compress(model?.data?.current, model.currency)}</TableCell>
            </TableRow>}
            <TableRow>
              <TableCell className={classes.header}>Currency</TableCell>
              <TableCell>{model.currency}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Type</TableCell>
              <TableCell>{snakeToCamel(model.type)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Subtype</TableCell>
              <TableCell>{snakeToCamel(model.subtype)}</TableCell>
            </TableRow>
            {model.data && model.data.charge &&
              <TableRow>
                <TableCell className={classes.header}>Charge Token</TableCell>
                <TableCell><MonoText>{model.data.charge}</MonoText></TableCell>
              </TableRow>
            }
            {model.data && model.data.card && model.data.card.last4 &&
              <TableRow>
                <TableCell className={classes.header}>Last 4 Digits</TableCell>
                <TableCell>{model.data.card.last4}</TableCell>
              </TableRow>
            }
            {model.data && model.data.card && model.data.card.brand &&
              <TableRow>
                <TableCell className={classes.header}>Brand</TableCell>
                <TableCell>{model.data.card.brand}</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

TransactionInfo.propTypes = {
  className: PropTypes.string,
};

export default TransactionInfo;
